(() => {
  const applyPatch = () => {
    const BasicHeader = customElements.get('basic-header');
    const StickyHeader = customElements.get('sticky-header');
    if (!BasicHeader || !StickyHeader) return false;

    // ---- Patch BasicHeader ---------------------------------------------------
    try {
      const bp = BasicHeader.prototype;

      // Fallback cho navigation area (support header layout without .header__bottom)
      Object.defineProperty(bp, 'headerNavigation', {
        configurable: true,
        get() {
          return (
            this.querySelector('.header__bottom') ||
            this.querySelector('.header__navigation') ||
            null
          );
        }
      });

      // Null-guard trong setHeight()
      bp.setHeight = function () {
        requestAnimationFrame(() => {
          const offsetHeight = Math.round(this.offsetHeight || 0);
          const offsetTop = Math.round((this.parentElement && this.parentElement.offsetTop) || 0);
          const navEl = this.headerNavigation;
          const navH = navEl ? Math.round(navEl.offsetHeight || 0) : 0;

          document.documentElement.style.setProperty('--header-height', `${offsetHeight}px`);
          document.documentElement.style.setProperty('--header-offset-top', `${offsetTop}px`);
          document.documentElement.style.setProperty('--header-navigation-height', `${Math.max(0, navH - 1)}px`);

          if (typeof this.calculateHeaderGroupHeight === 'function') {
            this.calculateHeaderGroupHeight();
          }
        });
      };
    } catch (e) {
      // noop
    }

    // ---- Patch StickyHeader --------------------------------------------------
    try {
      const sp = StickyHeader.prototype;

      sp.handleNavigationToggle = function (event) {
        event && event.preventDefault && event.preventDefault();
        const btn = this.navigationToggleButton;
        const nav = this.headerNavigation;
        if (!btn || !nav) return;

        this.navigationManuallyToggled = true;
        const isHidden = nav.classList.contains(this.classes.hide);

        setTimeout(() => {
          document.body.classList.toggle(this.classes.isHideNav, !isHidden);
        }, isHidden ? 0 : 250);

        nav.classList.toggle(this.classes.hide, !isHidden);
        nav.classList.toggle(this.classes.show, isHidden);
        btn.setAttribute('aria-expanded', String(isHidden));

        setTimeout(() => {
          this.navigationManuallyToggled = false;
        }, 1000);
      };

      sp.handleScrolledPastHeader = function (scrollTop, headerBoundsBottom) {
        if (this.headerSection) {
          this.headerSection.classList.add(this.classes.headerScrolled);
        }

        if (this.collapseOnScroll) {
          if (this.navigationToggleButton) {
            this.navigationToggleButton.classList.add(this.classes.show);
          }
          if (!this.navigationManuallyToggled && this.headerNavigation && !this.headerNavigation.classList.contains(this.classes.show)) {
            this.headerNavigation.classList.add(this.classes.hide);
            document.body.classList.add(this.classes.isHideNav);
          }
        }

        if (this.isAlwaysSticky) {
          document.body.classList.add(this.classes.pinned);
        } else {
          const isScrollingUp = this.scrollDirection === 'up';
          const isNearHeader = scrollTop < headerBoundsBottom + 100;
          const hasScrolledEnough = this.scrollDistance >= this.scrollThreshold;

          if (isScrollingUp || isNearHeader) {
            document.body.classList.add(this.classes.pinned);
          } else if (!this.navigationManuallyToggled && hasScrolledEnough) {
            document.body.classList.remove(this.classes.pinned);
          }
        }
      };

      sp.handleScrolledBeforeHeader = function () {
        if (this.headerSection) {
          this.headerSection.classList.remove(this.classes.headerScrolled);
        }

        if (this.collapseOnScroll) {
          if (!this.navigationManuallyToggled) {
            document.body.classList.remove(this.classes.isHideNav);
            if (this.headerNavigation) {
              this.headerNavigation.classList.remove(this.classes.hide);
              this.headerNavigation.classList.remove(this.classes.show);
            }
            if (this.navigationToggleButton) {
              this.navigationToggleButton.setAttribute('aria-expanded', 'false');
            }
          }
          if (this.navigationToggleButton) {
            this.navigationToggleButton.classList.remove(this.classes.show);
          }
        }

        if (this.isAlwaysSticky) {
          document.body.classList.remove(this.classes.pinned);
        }
      };

      const origConnected = sp.connectedCallback;
      sp.connectedCallback = function () {
        if (origConnected) origConnected.call(this);
        if (!this.headerSection) {
          this.headerBounds = { top: 0, bottom: 0 };
        } else {
          this.headerBounds = this.headerSection.getBoundingClientRect ? this.headerSection.getBoundingClientRect() : { top: 0, bottom: 0 };
        }
      };
    } catch (e) {
      // noop
    }

    return true;
  };

  const waitAndPatch = () => {
    if (applyPatch()) return;
    const id = setInterval(() => {
      if (applyPatch()) clearInterval(id);
    }, 50);
    document.addEventListener('shopify:section:load', applyPatch);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndPatch);
  } else {
    waitAndPatch();
  }
})();
